import React, { useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button } from "antd";
import { sanitizeWidgetHtml } from "@components/DashboardAlt/Utils/sanitizeHtml";
import type { Banner } from "@store/reducers/banner.reducer";
import "@styles/styles-Banners.css";

export const Banners = () => {
    const banners: Banner[] = useSelector(({ banner }: any) => banner.banners);
    const stripRef = useRef<HTMLDivElement>(null);
    const [stripHeight, setStripHeight] = useState(0);

    // The strip is position:fixed (matching the fixed navbar so the two don't
    // separate during overscroll bounce), so an in-flow spacer must reserve
    // its height — which varies with banner count and text wrapping.
    useLayoutEffect(() => {
        const el = stripRef.current;
        if (!el) return;
        const observer = new ResizeObserver(() => setStripHeight(el.offsetHeight));
        observer.observe(el);
        return () => observer.disconnect();
    }, [banners.length]);

    if (!banners.length) return null;

    return (
        <>
            <div className="gpsdv-banners" ref={stripRef}>
                {banners.map(({ id, html_text, config }) => (
                    <Alert
                        key={id}
                        banner
                        showIcon
                        type={config.icon}
                        style={
                            {
                                "--banner-accent": config.color,
                                background: `color-mix(in srgb, ${config.color} 10%, white)`,
                            } as React.CSSProperties
                        }
                        message={<span dangerouslySetInnerHTML={{ __html: sanitizeWidgetHtml(html_text) }} />}
                        action={
                            config.button && (
                                <Button type="primary" size="small" href={config.button.url} target="_blank" rel="noopener noreferrer">
                                    {config.button.label}
                                </Button>
                            )
                        }
                    />
                ))}
            </div>
            <div style={{ height: stripHeight }} />
        </>
    );
};
